import moment from "moment";

export const getLastWeekDatesTitle = () => {
  const startDate = moment().subtract(1, "weeks").startOf("week").format("DD-MMM");
  const endDate = moment().subtract(1, "weeks").endOf("week").format("DD-MMM");
  return `(${startDate} to ${endDate})`;
};
